/**
 * Single source of truth for customer-facing DPC pricing copy.
 *
 * The authoritative price is the Stripe Price object referenced by the backend's
 * DPC_STRIPE_PRICE_ID env var — that is what actually gets charged. These constants
 * exist only for marketing copy rendered without a Stripe round-trip.
 *
 * Anywhere a real, account-specific amount is available (the DPC dashboard billing
 * section reads it from the live subscription), prefer that over these constants.
 *
 * If the Stripe price changes, update DPC_MONTHLY_PRICE here and DPC_PRICE_DISPLAY
 * in the backend — those are the only two places a price string should ever live.
 */

export const DPC_MONTHLY_PRICE = 49.99;

export const DPC_PRICE_DISPLAY = `$${DPC_MONTHLY_PRICE.toFixed(2)}`;

export const DPC_PRICE_PER_MONTH = `${DPC_PRICE_DISPLAY}/month`;

export const DPC_PRICE_PER_MONTH_SHORT = `${DPC_PRICE_DISPLAY}/mo`;

/** Format a live amount returned by the backend, falling back to the constant. */
export function formatBillingAmount(amount, currency = 'usd') {
  if (amount == null || Number.isNaN(Number(amount))) return DPC_PRICE_DISPLAY;
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: (currency || 'usd').toUpperCase(),
    }).format(Number(amount));
  } catch {
    return `$${Number(amount).toFixed(2)}`;
  }
}
